import React, { useState, useEffect } from 'react';
import { trackPromise } from 'react-promise-tracker';
import {
  Box,
  Card,
  makeStyles,
  Container,
  Divider,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  CardHeader,
  Button
} from '@material-ui/core';
import services from '../Services';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import { useNavigate } from 'react-router-dom';
import { LoadingComponent } from '../../../utils/newLoader';
import MaterialTable from 'material-table';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from "react-alert";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const screenCode = 'ITEMWAREHOUSE';

export default function WarehouseListing() {
  const classes = useStyles();
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState();
  const [warehouseData, setwarehouseData] = useState([]);
  const [IDDataForWarehouse, setIDDataForWarehouse] = useState(null);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [warehouseList, setWarehouseList] = useState({
    groupID: 0,
    factoryID: 0,
  })
  const navigate = useNavigate();

  alert = useAlert();

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
    setwarehouseData([]);
  }, [warehouseList.groupID]);

  useEffect(() => {
    setwarehouseData([]);
  }, [warehouseList.factoryID]);

  useEffect(() => {
    if (IDDataForWarehouse != null) {
      GetWarehouseDetails()
    }
  }, [IDDataForWarehouse]);

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('warehouse-listing-page-search-parameters-id')
    );
    if (IDdata && IDdata.isEdit) {
      getPermission(IDdata);
    } else {
      getPermission(null);
    }
  }, []);

  useEffect(() => {
    sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
  }, []);

  async function getPermission(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWITEMWAREHOUSE');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const initialValues = IDdata === null || !IDdata.isEdit;
    if (initialValues) {
      setWarehouseList({
        ...warehouseList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken()),
      });
    } else {
      setWarehouseList({
        ...warehouseList,
        groupID: parseInt(IDdata?.groupID),
        factoryID: parseInt(IDdata?.factoryID)
      });
      setIDDataForWarehouse(IDdata);
    }
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesForDropDown() {
    const factoryList = await services.getFactoryByGroupID(warehouseList.groupID);
    setFactories(factoryList);
  }

  async function GetWarehouseDetails() {
    const response = await services.GetWarehouseDetails(
      parseInt(warehouseList.factoryID),
      warehouseList.groupID
    );
    if (response.statusCode == "Success") {
      setwarehouseData(response.data);
    } else {
      alert.error(response.message);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  let encryptedID = '';

  function AddEditWarehouseDetails(warehouseID = '0') {
    encryptedID = btoa(warehouseID.toString());

    if (warehouseID !== '0') {
      let modelID = {
        groupID: parseInt(warehouseList.groupID),
        factoryID: parseInt(warehouseList.factoryID),
        entityTypeID: parseInt(warehouseList.entityTypeID),
        isEdit: true
      };
      sessionStorage.setItem('warehouse-listing-page-search-parameters-id', JSON.stringify(modelID));
    } else {
      sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
    }
    navigate('/app/Warehouse/addEdit/' + encryptedID);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;

    if (e.target.name === "groupID") {
      setWarehouseList({
        ...warehouseList,
        groupID: value,
        factoryID: 0
      });
    } else {
      setWarehouseList({
        ...warehouseList,
        [e.target.name]: value
      });
    }
    setwarehouseData([])
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={AddEditWarehouseDetails}
            isEdit={true}
            toolTiptitle={'Add Warehouse'}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Page className={classes.root} title="Warehouse">
      <Container maxWidth={false}>
        <LoadingComponent />
        <Formik
          initialValues={{
            groupID: warehouseList.groupID,
            factoryID: warehouseList.factoryID
          }}
          validationSchema={Yup.object().shape({
            groupID: Yup.number()
              .required('Group is required')
              .min('1', 'Select a Group'),
            factoryID: Yup.number().when([], {
              is: () => warehouseList.entityTypeID === "3",
              then: Yup.number().required('Estate is required').min("1", 'Estate is required'),
              otherwise: Yup.number().notRequired(),
            }),
          })}
          onSubmit={() => trackPromise(GetWarehouseDetails())}
          enableReinitialize
        >
          {({ errors, handleSubmit, touched }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <Card>
                  <CardHeader title={cardTitle('Warehouse')} />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{ marginBottom: '2rem' }}>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            size="small"
                            name="groupID"
                            onChange={e => handleChange(e)}
                            value={warehouseList.groupID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled
                            }}
                          >
                            <MenuItem value="0">
                              --Select Group--
                            </MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            size='small'
                            name="factoryID"
                            onChange={(e) => {
                              handleChange(e)
                            }}
                            value={warehouseList.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row-reverse" p={2}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size='small'
                        >
                          Search
                        </Button>
                      </Box>
                    </CardContent>
                    <Box minWidth={1000}>
                      {warehouseData.length > 0 ?
                        <MaterialTable
                          title="Warehouse Preview"
                          columns={[
                            { title: 'Warehouse Code', field: 'warehouseCode' },
                            { title: 'Warehouse Name', field: 'warehouseName' },
                            {
                              title: 'Status',
                              field: 'isActive',
                              render: rowData => {
                                if (rowData.isActive) {
                                  return 'Active';
                                } else {
                                  return 'Inactive';
                                }
                              }
                            }
                          ]}
                          data={warehouseData}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: 'left', height: '1%' },
                            cellStyle: { textAlign: 'left' },
                            columnResizable: false,
                            actionsColumnIndex: -1
                          }}
                          actions={[
                            {
                              icon: 'edit',
                              tooltip: 'Edit Warehouse',
                              onClick: (event, warehouseData) =>
                                AddEditWarehouseDetails(warehouseData.warehouseID)
                            }
                          ]}
                        /> : null}
                    </Box>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
}